import React, { useState, useEffect } from 'react';
import { Smartphone, Download, Apple, ExternalLink, QrCode } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function AppMobilePage() {
  const [appFiles, setAppFiles] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/app-files`).then(r => r.json()).then(setAppFiles).catch(() => {});
  }, []);

  const androidFile = appFiles.find(f => f.platform === 'android' && f.status === 'active');

  return (
    <div className="max-w-2xl mx-auto space-y-8" data-testid="app-mobile-page">
      <div className="text-center space-y-3">
        <div className="w-16 h-16 rounded-2xl bg-[#FF6B35]/20 flex items-center justify-center mx-auto">
          <Smartphone className="w-8 h-8 text-[#FF6B35]" />
        </div>
        <h1 className="text-2xl font-bold text-white">Application mobile ArcanApp</h1>
        <p className="text-[#999]">
          Retrouvez tous vos tournois, parties et messages directement sur votre smartphone.
        </p>
      </div>

      {/* Android */}
      <Card className="bg-[#1a1a1a] border-[#333]">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-[#3DDC84]/15 flex items-center justify-center">
              <Download className="w-6 h-6 text-[#3DDC84]" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">Android</h2>
              <p className="text-sm text-[#666]">Disponible en APK</p>
            </div>
          </div>
          {androidFile ? (
            <a href={`${API}${androidFile.download_url}`} download>
              <Button className="w-full bg-[#3DDC84] hover:bg-[#35c476] text-black font-semibold gap-2" data-testid="download-android-btn">
                <Download className="w-4 h-4" />
                Télécharger l'APK ({androidFile.version || 'dernière version'})
              </Button>
            </a>
          ) : (
            <div className="text-sm text-[#666] bg-[#252525] rounded-lg p-4">
              L'APK sera bientôt disponible. En attendant, vous pouvez installer l'application depuis Expo Go.
            </div>
          )}
          <div className="text-xs text-[#666] space-y-1">
            <p>1. Téléchargez le fichier APK ci-dessus</p>
            <p>2. Autorisez l'installation depuis des sources inconnues dans les paramètres</p>
            <p>3. Ouvrez le fichier APK et installez</p>
          </div>
        </CardContent>
      </Card>

      {/* iOS */}
      <Card className="bg-[#1a1a1a] border-[#333]">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center">
              <Apple className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">iOS (iPhone / iPad)</h2>
              <p className="text-sm text-[#666]">Bientôt sur l'App Store</p>
            </div>
          </div>
          <div className="text-sm text-[#999] bg-[#252525] rounded-lg p-4 space-y-3">
            <p className="font-medium text-white">En attendant, utilisez ArcanApp comme une web-app :</p>
            <ol className="list-decimal list-inside space-y-1.5 text-[#999]">
              <li>Ouvrez <span className="text-[#FF6B35] font-medium">arcanapp.com</span> dans Safari</li>
              <li>Appuyez sur le bouton <span className="text-white">Partager</span> (carré avec flèche)</li>
              <li>Sélectionnez <span className="text-white">"Sur l'écran d'accueil"</span></li>
              <li>Confirmez en appuyant sur <span className="text-white">"Ajouter"</span></li>
            </ol>
          </div>
        </CardContent>
      </Card>

      {/* PWA note */}
      <div className="text-center text-xs text-[#666]">
        ArcanApp est aussi disponible en Progressive Web App (PWA) sur tous les navigateurs modernes.
      </div>
    </div>
  );
}
